import { api } from '../config/base-api';
import type { Business } from 'types';

export interface SendVerificationCodeParams {
  leadId: string;
  productCode: string;
  business: Business;
}

export async function sendVerificationCode(
  { leadId, productCode, business }: SendVerificationCodeParams,
  isServer?: boolean
): Promise<void> {
  const requestUrl = isServer
    ? `http://localhost:3000/api/v1/lead/${leadId}/phones/send-verification`
    : `/api/v1/lead/${leadId}/phones/send-verification`;

  await api.post<void>(requestUrl, {
    productCode,
    business,
  });

  return;
}
